import { ConcreteEncodable } from "./ConcreteEncodable";

import { DateComparitorImplEncoder } from "../../encoder/DateComparitorImplEncoder";

import * as CubiqTS from "../../index";
import { DateComparitor } from "../DateComparitor";

export class DateComparitorImpl extends ConcreteEncodable implements DateComparitor {
  public static enType: string = "com.bcdfx.model.DateComparitorImpl";

  /*FID=1*/
  public lowerBound: string;
  /*FID=2*/
  public upperBound: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = DateComparitorImplEncoder.Instance;
    this.setEncodableType(DateComparitorImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "DateComparitorImpl[" +
      "lowerBound=" +
      this.lowerBound +
      "upperBound=" +
      this.upperBound +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
